import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { styled } from "@mui/material/styles";

import "./ErrorPricingModal.css";
import { SESSION_CORRELATIONID } from "../../../../../constants/constant";
import { ErrorPricingModalProps } from "../../../../../Interface/scheduler/form";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
  "& .MuiPaper-root": {
    minWidth: "280px",
    minHeight: "254px",
    maxWidth: "550px",
    paddingBottom: "0.6em",
    [theme.breakpoints.down("sm")]: {
      minWidth: "90%",
      maxWidth: "90%",
      margin: theme.spacing(1),
    },
    [theme.breakpoints.down("xs")]: {
      minWidth: "85%",
      maxWidth: "85%",
    },
  },
}));

const ErrorPricingModal = ({
  openModal,
  errorPriceModal,
  formConfig,
}: ErrorPricingModalProps) => {
  const errorPricingModal = errorPriceModal?.find(
    (modal) => modal.id === "error-pricing-modal"
  );
  if (!errorPricingModal && !openModal) {
    return null;
  }
  const title =
    errorPricingModal?.elements?.find((e) => e.type === "title")?.label ?? "";
  const text =
    errorPricingModal?.elements?.find((e) => e.type === "text")?.label ?? "";
  const button =
    errorPricingModal?.elements?.find((e) => e.type === "button")?.label ?? "";

  const redirectingConfirmation = () => {
    // redirecting confirmation page
    const redirectionUrl = formConfig?.redirectionPageUrl ?? "/confirmation";
    sessionStorage.removeItem(SESSION_CORRELATIONID);
    globalThis.location.replace(redirectionUrl);
  };
  return (
    <BootstrapDialog
      aria-labelledby="customized-dialog-title"
      open={openModal}
      data-testid="error-modal"
    >
      <DialogTitle
        sx={{ m: 0, p: 0.5 }}
        id="error-pricing-title"
        data-testid="error-pricing-title"
      >
        {title}
      </DialogTitle>
      <DialogContent className="error-pricing-content">
        <Typography
          className="error-pricing-text"
          align="center"
          data-testid="error-modal-text"
        >
          {text}
        </Typography>
      </DialogContent>

      <DialogActions className="error-pricing-actions">
        <Button
          autoFocus
          className="error-pricing-btn"
          data-testid="close-button"
          onClick={redirectingConfirmation}
        >
          {button}
        </Button>
      </DialogActions>
    </BootstrapDialog>
  );
};

export default ErrorPricingModal;
